import { IPublicClientApplication } from '@azure/msal-browser';
import { WinnerEventRequest } from '../../models/schemas';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import {
  createWinnerEvent,
  deleteWinnerEvent,
  getWinnerEvents,
  updateWinnerEvent,
} from './index';

export const createStaffProgramsWinnerEventsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  getWinnerEvents: (instance: IPublicClientApplication, programId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => getWinnerEvents(fetchContext, programId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('getWinnerEvents', isInFlight);
    },
  ),
  createWinnerEvent: (instance: IPublicClientApplication, programId: number, winnerEvent: WinnerEventRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => createWinnerEvent(fetchContext, programId, winnerEvent, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('createWinnerEvent', isInFlight);
    },
  ),
  updateWinnerEvent: (instance: IPublicClientApplication, programId: number, eventId: number, winnerEvent: WinnerEventRequest) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateWinnerEvent(fetchContext, programId, eventId, winnerEvent, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateWinnerEvent', isInFlight);
    },
  ),
  deleteWinnerEvent: (instance: IPublicClientApplication, programId: number, eventId: number) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => deleteWinnerEvent(fetchContext, programId, eventId, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('deleteWinnerEvent', isInFlight);
    },
  ),
});
